import { render } from "./NewMatchForm.vue?vue&type=template&id=d2aa5ce0"
import script from "./NewMatchForm.vue?vue&type=script&lang=js"
export * from "./NewMatchForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__